import React, { useState, useEffect, useCallback } from 'react';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { ExclamationTriangleIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { setErrorDialogListener, removeErrorDialogListener, DialogType } from '../utils/handleApiError';

export default function ErrorDialog() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState<string[]>([]);
  const [type, setType] = useState<DialogType>('error');

  const handleError = useCallback((msgs: string[], msgType: DialogType) => {
    setMessages(msgs);
    setType(msgType);
    setOpen(true);
  }, []);

  useEffect(() => {
    setErrorDialogListener(handleError);
    return () => removeErrorDialogListener();
  }, [handleError]);

  const isSuccess = type === 'success';

  return (
    <Dialog open={open} onClose={() => setOpen(false)} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
          <div className="flex items-start gap-3">
            {isSuccess ? (
              <CheckCircleIcon className="h-6 w-6 text-green-600 flex-shrink-0 mt-0.5" />
            ) : (
              <ExclamationTriangleIcon className="h-6 w-6 text-red-600 flex-shrink-0 mt-0.5" />
            )}
            <div className="flex-1">
              <DialogTitle className="text-lg font-semibold text-gray-900">
                {isSuccess ? 'Sikeres' : 'Hiba'}
              </DialogTitle>
              <div className="mt-2 space-y-1">
                {messages.map((msg, i) => (
                  <p key={i} className="text-sm text-gray-700">{msg}</p>
                ))}
              </div>
            </div>
          </div>
          <div className="mt-5 flex justify-end">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className={`rounded-md px-4 py-2 text-sm font-semibold text-white focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                isSuccess
                  ? 'bg-green-600 hover:bg-green-500 focus:ring-green-600'
                  : 'bg-red-600 hover:bg-red-500 focus:ring-red-600'
              }`}
            >
              Bezárás
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
